import { html, customElement } from '@adobe/edex/ui/edex-lit';
import { EdexTagName } from '@adobe/edex/ui/shared/constants';
import { BaseElement } from '@adobe/edex/ui/components/base.element';
import { unsafeHTML } from '@adobe/edex/ui/edex-lit';
import { sanitize } from '@adobe/edex/ui/utils';
import styles from './edex-html.lit.scss';
import { RichTextInlineLinkClicked } from '@adobe/edex/ui/types/payload';

@customElement(EdexTagName.html)
export class EdexHtml extends BaseElement {
  static styles = styles;
  static get properties() {
    return {
      source: { type: String },
    };
  }
  source: string;

  /**
   * <a>click me</a>
   *   or
   * <a><strong><em>click me</em></strong></a>
   */
  static getClosestClickedLink(e: Event): HTMLAnchorElement {
    const target = e.target as HTMLElement;
    return target.closest('a');
  }

  handleInlineLinkClick(e: Event) {
    const link = EdexHtml.getClosestClickedLink(e);

    // fixes same domain links router "not found" issue
    if (link) {
      link.target = '_blank';
      this.emitEvent<RichTextInlineLinkClicked>('linkClicked', { link });
    }
  }

  render() {
    const { source } = this;
    return html`
      <div class="container" @click="${this.handleInlineLinkClick}">${unsafeHTML(sanitize(source))}</div>
    `;
  }
}
